import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout';

const TABS = [
  { key: 'errors',     label: '에러 로그',  icon: 'ti-alert-triangle' },
  { key: 'access',     label: '실시간 접속', icon: 'ti-activity' },
  { key: 'suspicious', label: '의심 IP',    icon: 'ti-shield-exclamation' },
  { key: 'blocked',    label: '차단 IP',    icon: 'ti-ban' },
  { key: 'alert',      label: '이상 보고',  icon: 'ti-mail' },
];


// 미구현 탭 목록 — 백엔드 인프라(AccessLog 테이블, IP 차단 테이블, 알림 설정 테이블) 구현 후 활성화
const PENDING_TABS = new Set(['errors', 'access', 'suspicious', 'blocked', 'alert']);

function PendingTab({ label }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '60px 0', gap: 12, color: 'var(--color-text-tertiary)',
    }}>
      <i className="ti ti-tool" style={{ fontSize: 32 }} />
      <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--color-text-secondary)' }}>
        {label} — 준비 중
      </div>
      <div style={{ fontSize: 12, maxWidth: 360, textAlign: 'center', lineHeight: 1.6 }}>
        해당 기능은 백엔드 인프라 구현 후 활성화됩니다.
      </div>
    </div>
  );
}

export default function AdminDevPage() {
  const location = useLocation();
  const initTab  = new URLSearchParams(location.search).get('tab') || 'errors';
  const [activeTab, setActiveTab] = useState(
    TABS.find(t => t.key === initTab) ? initTab : 'errors'
  );

  useEffect(() => {
    const tab = new URLSearchParams(location.search).get('tab');
    if (tab && TABS.find(t => t.key === tab)) setActiveTab(tab);
  }, [location.search]);

  return (
    <AdminLayout pageId="developer">
      <div className="admin-topbar">
        <h1>개발자 페이지</h1>
        <div className="admin-topbar__right">
          <span style={{ fontSize: 12, color: 'var(--color-text-tertiary)' }}>로그 · IP · 이상 보고</span>
          <span className="admin-badge"><i className="ti ti-user" /> admin</span>
        </div>
      </div>

      {/* 탭 바 */}
      <div className="ag-tab-bar" style={{ marginBottom: 16 }}>
        {TABS.map(tab => (
          <button
            key={tab.key}
            className={`ag-tab${activeTab === tab.key ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            <i className={`ti ${tab.icon}`} /> {tab.label}
          </button>
        ))}
      </div>

      {PENDING_TABS.has(activeTab) && (
        <div className="ag-card">
          <PendingTab label={TABS.find(t => t.key === activeTab)?.label ?? ''} />
        </div>
      )}
    </AdminLayout>
  );
}
